import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Textbox } from '../../models/editors/textbox.model';
import { Textarea } from '../../models/editors/textarea.model';
import { atLeastOneLang } from '../../shared/validators/langField.validator';
import { FormControlService } from '../../shared/services/form-control.service';
import { ApiService } from '../../shared/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from '../../shared/services/alert.service';
import { FormDetailBase } from '../../shared/components/base/form-detail/form-detail.base.component';
import { Grant } from '../../models/certs/grants.model';
import { ContainedMany } from '../../models/editors/contained-many.model';

@Component({
  selector: 'swb-grant-detail',
  templateUrl: './../../shared/components/base/form-detail/form-detail.base.component.html',
  providers: [FormControlService],
  encapsulation: ViewEncapsulation.None
})
export class GrantDetailComponent extends FormDetailBase<Grant> implements OnInit {

  public url = 'subsidies';
  protected _redirect = './certs';

  public entity = new Grant({});

  public get fieldsConfig(): Array<any> {
    return [
      new Textbox({
        key: 'title',
        label: 'Titulek',
        validators: [atLeastOneLang],
        isMultilang: true
      }),
      new Textarea({
        key: 'content',
        label: 'Popis',
        validators: [atLeastOneLang],
        isMultilang: true,
        wysiwyg: 'job-detail'
      }),
      new ContainedMany({
        key: 'files',
        label: 'Galerie',
        entities: this.entity.files,
        files: this.entity.files,
        apiUrl: 'files',
        upload: true,
        imgOnly: false
      })
    ];
  }

  public formEditors: any;
  public isInitialized = false;
  public isSaving = false;

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _router: Router,
    _alertService: AlertService,
    private _route: ActivatedRoute
  ) {
    super(
      _formService,
      _apiService,
      _router,
      _alertService
    );
  }

  ngOnInit() {

    if (typeof this._route.snapshot.params['id'] !== 'undefined') {
      this._id = this._route.snapshot.params['id'];
    }

    this._getEntity();

  }


}
